import React from "react";
import { css } from "@emotion/react";
import { Div } from "@components/Markup";

const SectionIntro = ({ children }) => {
  return (
    <Div
      css={css`
        background-color: #e2d3d1;

        img {
          border-radius: 24px;

          @media (min-width: 768px) {
            border-radius: 28px;
          }
        }
      `}
    >
      {children}
    </Div>
  );
};

export default SectionIntro;
